<template>
  <div>
    <user-edit
      v-if="$store.state.user.user"
      :item="user"
      :role-input-enabled="isAdmin"
      :password-input-enabled="isCreate"
      :on-submit="isCreate ? create : update"
      :on-delete="deleteItem"
      :is-own-profile="ownProfile"
      :serverErrors="errors"
    />
    <user-change-password v-if="ownProfile" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import UserEdit from '../components/user/UserEdit.vue'
import UserChangePassword from '../components/user/UserChangePassword.vue'
import UserMixin from '../mixins/UserMixin'

export default {
  name: 'UserProfile',
  components: {
    UserEdit,
    UserChangePassword
  },
  mixins: [UserMixin],
  data: () => ({
    isCreate: null,
    errors: {
      fields: [],
      messages: []
    }
  }),
  methods: {
    ...mapActions('user', [
      'getUser',
      'createUser',
      'updateUser',
      'deleteUser'
    ]),
    create(userData) {
      this.createUser(userData)
        .then((result) => {
          if (result.error) {
            this.errors.messages.push(result.error)
            this.errors.fields = result.fields
          } else {
            if (typeof result === 'string') {
              result = JSON.parse(result)
            }
            if (this.isSystemAdmin) {
              this.$router.push(`/users?c=${result.company}`)
            } else {
              this.$router.push('/users')
            }
          }
        })
        .catch((exc) => {
          this.errors.messages.push(exc.message)
        })
    },
    update(userData, userId) {
      this.updateUser({ userId, userData })
      this.$router.go()
    },
    deleteItem(userId) {
      this.deleteUser(userId)
      this.$router.push('/users')
    }
  },
  computed: {
    company() {
      if (this.isSystemAdmin && this.$route.query.c) {
        return this.$route.query.c
      }
      return this.$store.state.auth.user.company
    },
    ownProfile() {
      return (
        this.$route.params.id &&
        parseInt(this.$route.params.id) ===
          parseInt(this.$store.state.auth.user.id)
      )
    },
    user() {
      let user
      user = { ...this.$store.state.user.user }
      user.company = this.company
      return user
    }
  },
  mounted() {
    const id = this.$route.params.id
    if (id === 'create') {
      this.isCreate = true
      this.$store.commit('user/getUserSuccess', {
        username: '',
        firstname: '',
        lastname: '',
        password: '',
        company: this.$store.state.auth.user.company,
        role: 'companyuser'
      })
    } else {
      this.isCreate = false
      this.getUser(this.$route.params.id)
    }
  },
  watch: {
    user: {
      deep: true,
      immediate: true,
      handler(user) {
        if (user) {
          if (this.$route.params.id !== user.id) {
            this.getUser(this.$route.params.id)
          }
        }
      }
    }
  }
}
</script>
